export default __webpack_public_path__ + "src/assets/app-store-badge.f594c96f866fca58c0f8d734dd5cb328.png";